import { useContext } from 'react';
import AppConfigContext from '../AppConfigContext';

const useAppConfigContext = () => useContext(AppConfigContext)

export default useAppConfigContext
